import $ from 'jquery';
import { gsap } from 'gsap';
import { Back } from 'gsap/all';
import { NOTIFICATION_EVENTS } from '../../../constants/notifications';
import { hashString } from "../../../socket/socketHelper";

const trafficNotificationItem = (data, id, text, classType, dataLang = '') => `           
<div class="alert-notification ${classType}" id="notif-${id}">
  <div class="img-wrapper">
    <img src="${data.userAvatarUrl}" onError='this.src = "textures/defaultAvatar.png"'/>
  </div>
  <p data-lang='${dataLang}'>${text}</p>
</div>
`;

const notificationItem = (id, text, classType, dataLang, icon = '') => `           
<div class="alert-notification ${classType}" id="notif-${id}">
  ${icon ? `<div class="img-wrapper">${icon}</div>` : `<span class="material-icons alert-icon-notification">info</span>`}
  <p data-lang='${dataLang}'>${text}</p>
  <span class="material-icons close-notification">close</span>
</div>
`;

const notifications = {};

class AlertNotification {
  constructor({ model }) {
    this.defaults = {
      text: '',
      showTime: 5000,
      classType: 'neutral',
      area: 'bottom left',
      autoRemove: true,
      withSound: false,
      song: 'message',
      dataLang: 'empty'
    };

    this.model = model;
    this.counter = 0;

    this.initEventListeners();
  }

  // Initialize event listeners for notifications
  initEventListeners() {
    $(document).on('click', '.alert-notification', (e) => {
      const id = $(e.currentTarget).attr('id').replace('notif-', '');
      this.removeNotification(id);
    });

    this.model?.addEventListener(NOTIFICATION_EVENTS.ALERT, (e) => {
      const data = { ...this.defaults, ...e.data };
      this.createNotification(data);
    });
  }

  // Remove notification by ID
  removeNotification(id) {
    if (!notifications[id]) return;

    const { container } = notifications[id];
    const item = container.find(`#notif-${id}`);
    delete notifications[id];
    item.remove();
  }

  // Create and display a traffic notification
  createTrafficNotification({ user, text, showTime = 2000, classType = 'neutral', area = 'bottom left', autoRemove = true }) {
    const id = this.counter++;
    const item = $(trafficNotificationItem(user, id, text, classType));
    const container = this.getContainer(area);
    container.append(item);

    notifications[id] = { item, container };
    this.playAnimation({ item, showTime, area, id, autoRemove });
  }

  // Create and display a general notification
  createNotification(data) {
    const { text, showTime, classType, area, autoRemove, withSound, song, dataLang, icon = '' } = data;
    const id = hashString(text);
    if (notifications[id]?.item) {
      this.playAnimation({ item: notifications[id].item, showTime, area, id, autoRemove, extendRemoving: true });
      return
    }

    const item = $(notificationItem(id, text, classType, dataLang, icon));
    const container = this.getContainer(area);
    container.append(item);

    notifications[id] = { item, container };
    withSound && this.model?.playAudioNotification(song);

    this.playAnimation({ item, showTime, area, id, autoRemove });
  }

  // Play animation for showing and hiding notifications
  playAnimation({ item, showTime, area, id, autoRemove, extendRemoving = false }) {
    const padding = window.innerWidth > 915 ? 24 : 0;
    const itemWidth = item[0].offsetWidth + padding;

    // Define entry and exit positions based on area
    const positions = this.getAnimationPositions(area, itemWidth);
    const fromTo = (element, to, from = null) => {
      if (from) {
        gsap.fromTo(element, from, to)
      } else {
        gsap.to(element, to)
      }
    }

    if (!extendRemoving) {
      fromTo(item[0], { opacity: 1, x: positions.xIn, y: positions.yIn, duration: 0.4, ease: Back.easeOut }, positions.from);
    }

    if (autoRemove || extendRemoving) {
      if (notifications[id].tweenOutTimeout) {
        clearTimeout(notifications[id].tweenOutTimeout);
      }
      if (notifications[id].removeTimeout) {
        clearTimeout(notifications[id].removeTimeout);
      }

      notifications[id].tweenOutTimeout = setTimeout(() => {
        fromTo(item[0], { opacity: 0, x: positions.xOut, y: positions.yOut, duration: 0.4 }, positions.from)
      }, showTime);
      notifications[id].removeTimeout = setTimeout(() => this.removeNotification(id), showTime + 800);
    }
  }

  // Define animation positions based on area
  getAnimationPositions(area, itemWidth) {
    const positions = { xIn: 0, xOut: 0, yIn: 0, yOut: 0 };

    switch (area) {
      case 'bottom right': positions.xIn = positions.xOut = '-100%'; break;
      case 'bottom center': positions.yOut = '100%'; break;
      case 'bottom left': positions.xIn = '0%'; positions.from = { x: '-10%' }; break;
      case 'middle left': positions.xIn = '0%'; positions.from = { x: '-10%' }; break;
      case 'middle right': positions.xIn = positions.xOut = '-100%'; break;
      case 'top right': positions.xIn = positions.xOut = `-${itemWidth}px`; break;
      case 'top center': positions.yOut = '-100%'; break;
      case 'top left': positions.xIn = '0%'; positions.from = { x: '-10%' }; break;
      default: positions.xIn = positions.xOut = '-100%';
    }

    return positions;
  }

  // Retrieve the appropriate container based on area
  getContainer(area) {
    const areas = {
      'bottom right': '#notifications_bottom_right',
      'bottom center': '#notifications_bottom_center',
      'bottom left': '#notifications_bottom_left',
      'middle left': '#notifications_middle_left',
      'middle right': '#notifications_middle_right',
      'top right': '#notifications_top_right',
      'top center': '#notifications_top_center',
      'top left': '#notifications_top_left',
    };
    return $(areas[area] || '#notifications_top_right');
  }
}

export default AlertNotification;
